import { AuditProgramScopeBean } from 'app/model/audit-program-scope-bean';
import { AuditorBenchAuditDetailDTO } from 'app/model/auditor-bench-audit-detail-dto';
import { AuditorBenchAuditDetailScopeDetailDTO } from 'app/model/auditor-bench-audit-detail-scope-detail-dto';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { CommonDTO } from 'app/model/common-dto';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { UrlConfigService } from './url-config.service';

@Injectable({
  providedIn: 'root',
})
export class AuditDetailsService {
  //url = environment.SERVER_URL;
  url: string;

  constructor(private http: HttpClient, private urlConfigService: UrlConfigService) {
    this.url = this.urlConfigService.apiServerUrl;
  }

  getAuditProgramScopeStatusNList(auditorBenchAuditDetailDTO: AuditorBenchAuditDetailDTO) {
    return this.http.post(`${this.url}auditorBench/auditDetail/list`, auditorBenchAuditDetailDTO);
  }

  getAuditProgramScopeDetail(auditorBenchAuditDetailDTO: AuditorBenchAuditDetailDTO) {
    return this.http.post(
      `${this.url}auditorBench/auditDetail/scopeDetail`,
      auditorBenchAuditDetailDTO
    );
  }

  updateplanCompletionDate(
    auditorBenchAuditDetailScopeDetailDTO: AuditorBenchAuditDetailScopeDetailDTO
  ) {
    return this.http.post(
      `${this.url}auditorBench/auditDetail/updatePlanCompletionDate`,
      auditorBenchAuditDetailScopeDetailDTO
    );
  }
  getplanandrevisedCompletionDate(
    auditorBenchAuditDetailScopeDetailDTO: AuditorBenchAuditDetailScopeDetailDTO
  ) {
    return this.http.post(
      `${this.url}auditorBench/auditDetail/getPlanandrevisedCompletionDate`,
      auditorBenchAuditDetailScopeDetailDTO
    );
  }

  auditProgramActionOnScope(
    auditorBenchAuditDetailScopeDetailDTO: AuditorBenchAuditDetailScopeDetailDTO
  ) {
    return this.http.post(
      `${this.url}auditorBench/auditDetail/actionOnScope`,
      auditorBenchAuditDetailScopeDetailDTO
    );
  }

  auditProgramSubScopeCrudOperations(auditProgramScopeBean: AuditProgramScopeBean) {
    return this.http.post(
      `${this.url}auditorBench/auditDetail/add-sub-scope`,
      auditProgramScopeBean
    );
  }

  auditProgramSaveRejoinderRcoComment(
    auditorBenchAuditDetailScopeDetailDTO: AuditorBenchAuditDetailScopeDetailDTO
  ) {
    return this.http.post(
      `${this.url}auditorBench/auditDetail/save-re-joinder-rco-comment`,
      auditorBenchAuditDetailScopeDetailDTO
    );
  }

  auditProgramSaveGvRemarks(
    auditorBenchAuditDetailScopeDetailDTO: AuditorBenchAuditDetailScopeDetailDTO
  ) {
    return this.http.post(
      `${this.url}auditorBench/auditDetail/visibilityRemarks`,
      auditorBenchAuditDetailScopeDetailDTO
    );
  }

  checkforgvRemarksStatus(
    auditorBenchAuditDetailScopeDetailDTO: AuditorBenchAuditDetailScopeDetailDTO
  ) {
    return this.http.post(
      `${this.url}auditorBench/auditDetail/checkgvRemarkStatus`,
      auditorBenchAuditDetailScopeDetailDTO
    );
  }

  checkforFirstRemark(
    auditorBenchAuditDetailScopeDetailDTO: AuditorBenchAuditDetailScopeDetailDTO
  ) {
    return this.http.post(
      `${this.url}auditorBench/auditDetail/checkforFirstRemark`,
      auditorBenchAuditDetailScopeDetailDTO
    );
  }

  getRemarksList(auditorBenchAuditDetailScopeDetailDTO: AuditorBenchAuditDetailScopeDetailDTO) {
    return this.http.post(
      `${this.url}auditorBench/auditDetail/getRemarksList`,
      auditorBenchAuditDetailScopeDetailDTO
    );
  }
  deleteGvRemarks(auditorBenchAuditDetailScopeDetailDTO: AuditorBenchAuditDetailScopeDetailDTO) {
    return this.http.post(
      `${this.url}auditorBench/auditDetail/deleteGvRemarks`,
      auditorBenchAuditDetailScopeDetailDTO
    );
  }
  //To get Document Repository attachment list, 23-09-2021
  getAuditProgramScopeAttachmentList(commanDTO: CommonDTO) {
    return this.http.post(`${this.url}auditProgram/auditProgramScopeAttachmentList`, commanDTO);
  }

  addAuditorVisibilityRemarks(
    auditorBenchAuditDetailScopeDetailDTO: AuditorBenchAuditDetailScopeDetailDTO
  ) {
    return this.http.post(
      `${this.url}auditorBench/auditDetail/addGvRemarks`,
      auditorBenchAuditDetailScopeDetailDTO
    );
  }
}
